/**
 * 模板市场-筛选条件状态定义与同步
 * @author VenDream
 * @since 17/11/7
 */

import VARIABLES from 'constants/variable.json5';
import ACTIONS from 'constants/action.json5';
import clone from '@fe/common/lib/clone';
import { isInEditorIframe } from 'utils/env';

const inEditorIframe = isInEditorIframe();

const initialState = {
  filters: {
    [VARIABLES.RECOMMEND]: [],
    [VARIABLES.RP_STORE]: [],
    [VARIABLES.RP_H5]: [],
    [VARIABLES.RP_SPA]: [],
    [VARIABLES.RP_VIDEO]: [],
    [VARIABLES.RP_GAME]: [],
    [VARIABLES.CHAJIAN]: [],
    [VARIABLES.VIP]: [],
    [VARIABLES.ENTERPRISE]: [],
    [VARIABLES.MY_TPL]: [],
    [VARIABLES.SEARCH]: [],
  },
  openZoneFilters: {},
  openSearchFilters: {
    firstId: '4',
    systemTags: [],
    customTagIds: [],
    mostHot: true,
  },
  submitFilters: {},
  tplCornerLabelObj: {},
  orgZoneFilters: [],
  orgZoneSearchFilters: {
    type: '',
    tags: [],
  },
};

/**
 * 解析筛选条件数据
 * @param {Array} filters 筛选条件
 * @param {String} category 一级类别
 */
function parseFilters(category, filters) {
  const parsedFilters = [];
  const filterList = filters && filters.length > 0 ? filters[0] : [];
  for (const filter of filterList) {
    const { showType, type, children = [], showName, name, fieldKey } = filter;
    const items = [];
    let parsedFilter = {};

    // 一般的文本项
    if (showType === 0) {
      if (children) {
        for (const tag of children) {
          items.push({ value: tag.fieldKey, text: tag.name });
        }
      }
      if (
        category !== 'ENTERPRISE' &&
        category !== 'VIP' &&
        category !== 'MY_TPL'
      ) {
        items.unshift({
          text: '全部',
          value: 'ALL',
        });
      }
      parsedFilter = {
        showType,
        type,
        key: fieldKey,
        name: showName || name,
        subFilters: items,
      };
      parsedFilters.push(parsedFilter);
    } else {
      let parsedFilter = {
        showType: 1,
        name: '其他',
        subFilters: filters[0],
      };
      parsedFilters.push(parsedFilter);
      break;
    }
  }
  if (filters && filters[1]) {
    let parsedFilter = {
      showType: 1,
      name: '其他',
      subFilters: filters[1],
    };
    parsedFilters.push(parsedFilter);
  }
  return parsedFilters;
}

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.SET_STORE_FILTERS: {
      const { category, filters } = action.payload;

      /**
       * 2021年9月7日 by zhouruibin
       * 由于模板市场嵌入在编辑器中显示时 需要强行过滤掉 游戏和短视频类模板 故在此做改造
       */
      if (inEditorIframe && category === VARIABLES.SEARCH) {
        const tplSpecies = filters[0].find(f => f.fieldKey === 'tplSpecies');
        tplSpecies.children = tplSpecies.children.filter(
          t => !t.includes('短视频')
        );
      }
      return {
        ...state,
        filters: {
          ...state.filters,
          [category]: parseFilters(category, filters),
        },
      };
    }
    case ACTIONS.SET_SUBMIT_FILTERS: {
      return {
        ...state,
        submitFilters: { ...state.submitFilters, ...action.filters },
      };
    }
    case ACTIONS.CLEAR_SUBMIT_FILTERS: {
      return {
        ...state,
        submitFilters: {},
        openSearchFilters: {
          ...state.openSearchFilters,
          systemTags: [],
          customTagIds: [],
        },
      };
    }
    //逐个删除过滤条件
    case ACTIONS.CLEAR_SINGLE_FILTER: {
      let copySubmitFilters = clone(state.submitFilters, true);
      delete copySubmitFilters.isUrlParam;
      delete copySubmitFilters[action.key];
      return { ...state, submitFilters: copySubmitFilters };
    }
    //存储当前一级分类下的所有角标key、value
    case ACTIONS.SET_STORE_CORNER_LABEL: {
      return { ...state, tplCornerLabelObj: action.payload.tplCornerLabelObj };
    }
    // 设置平台专区筛选条件
    case ACTIONS.SET_OPEN_ZONE_FILTERS: {
      return {
        ...state,
        openZoneFilters: action.payload.openZoneFilters,
        openSearchFilters: action.payload.openSearchFilters,
      };
    }
    // 设置平台专区查询条件
    case ACTIONS.SET_OPEN_SEARCH_FILTERS: {
      return {
        ...state,
        openSearchFilters: {
          ...state.openSearchFilters,
          ...action.filters,
        },
      };
    }
    // 设置企业专区筛选条件
    case ACTIONS.SET_ORG_ZONE_FILTERS: {
      return {
        ...state,
        orgZoneFilters: action.filters,
      };
    }
    // 设置企业专区查询条件
    case ACTIONS.SET_ORG_ZONE_SEARCH_FILTERS: {
      return {
        ...state,
        orgZoneSearchFilters: {
          ...state.orgZoneSearchFilters,
          ...action.filters,
        },
      };
    }
    default:
      return state;
  }
};
